<template>
    <div class="container">
         <basic-information/>
    </div>

</template>
<script>
     import basicInformation from './common/basicInformation';
     export default {
         components: {  basicInformation},
        methods: {
            downStatement() {
                // this.$router.push({name:'/basicInformation', params:{downloadFlag:true}})
            },
        },
    }
</script>

<style scoped lang="scss">
    .line {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
    }

</style>